import { gql } from "graphql-tag";

export const QUERY = gql`
  query RelatedInterestActions($interestListID: ID!, $interestID: ID!) {
    interest(id: $interestID) {
      id
      status {
        name
        changedAt
      }
      interestListId
      userId
    }

    interestList(id: $interestListID) {
      id
      waitListId
    }

    activityFeed(resourceId: $interestID) {
      id
      name
      insertedAt
      title
      type
      note
      authorFullName
      message {
        status
        error {
          code
          message
        }
        recipientName
        body
        mobileNumber
      }
      metadata {
        to
        emailSubject
        emailBody
        viewerName
        errorsMap
        updateDiff
        reason
        activityContent
      }
      letterJob {
        lobLetterId
        status
        errorMessage
      }
    }
  }
`;

export const CHANGE_STATUS = gql`
  mutation ChangeInterestStatus($interestId: ID!, $status: String!, $reason: String) {
    changeInterestStatus(interestId: $interestId, status: $status, reason: $reason)
  }
`;

export const SKIP_INTEREST = gql`
  mutation skipInterestAction($data: SkipInterestInput!) {
    skipInterest(data: $data) {
      id
      note
    }
  }
`;

export const SKIP_INTERESTS = gql`
  mutation skipInterestsAction($interestIds: [ID!], 
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int,
    $reason: String!) {
    skipInterests(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom,
      note: $reason
    )
  }
`;

export const TAG_ELIGIBILITY = gql`
  mutation tagEligible($interestId: ID!, $isEligible: Boolean!) {
    tagInterestAsEligible(interestId: $interestId, isEligible: $isEligible) {
      id
    }
  }
`;

export const SEND_FULL_APP = gql`
mutation sendForm($interestId: ID!, $type: FormType!, $deadline: String!) {
  sendFormToInterest(type: $type, interestId: $interestId, deadline: $deadline) {
    id
  }
}
`;

export const SEND_FULL_APP_TO_INTERESTS = gql`
mutation sendFormToInterests($interestIds: [ID!]!, $type: FormType!, $deadline: String!) {
  sendFormToInterests(type: $type, interestIds: $interestIds, deadline: $deadline) {
    type
  }
}
`;

export const SYNC_ONE_SITE_GUEST_CARD = gql`
mutation syncOneSiteGuestCard($interestId: ID!) {
  onesiteSyncGuestCard(interestId: $interestId){
    interestId
  }
}
`;
